function TabGroup(name, order, enabled) {
	this.prepends = [];
	this.name = name;
	this.appends = [];
	this.elements = [];
	this.enabled = enabled;
	this.order = order;

	this.enable = function() {
		this.enabled = true;
	}

	this.disable = function() {
		this.enabled = false;
	}

	this.prepend = function(element, pos) {
		if (pos == undefined) pos = this.prepends.length;
		this.prepends.push({'e': element, 'p': pos});
		this.prepends.sort(function(a, b) {
			if (a.p < b.p) return 1;
			else if (a.p > b.p) return -1;
			return 0;
		});

		this.rebuild();
	};

	this.append = function(element, pos) {
		if (pos == undefined) pos = this.appends.length;
		this.appends.push({'e': element, 'p': pos});
		this.appends.sort(function(a, b) {
			if (a.p < b.p) return -1;
			else if (a.p > b.p) return 1;
			return 0;
		});

		this.rebuild();
	}

	this.insertAt = function(at, obj) {
		if (at < this.prepends.length) {
			var t = {'e': obj, 'p': at};
			this.prepends.splice(at, 0, t);
		}
		else {
			var t = {'e': obj, 'p': at - this.prepends.length};
			this.appends.splice(at - this.prepends.length, 0, t);
		}
		
		this.rebuild();
	}

	this.removeById = function(id) {
		var found = false;

		for(var r in this.prepends) {
			if (this.prepends[r].e.id == id) {
				found = r;
				break;
			}
		}

		if (found !== false) {
			this.prepends.splice(r, 1);
		}		


		found = false;

		for(var r in this.appends) {
			if (this.appends[r].e.id == id) {
				found = r;
				break;
			}
		}

		if (found !== false) {
			this.appends.splice(r, 1);
		}

		this.rebuild();
	}

	this.rebuild = function() {
		var result = [];
		for(var i in this.prepends) {result.push(this.prepends[i].e)};
		for(var i in this.appends) {result.push(this.appends[i].e)};
		this.elements = result;
	}

	this.clear = function() {
		this.appends = [];
		this.prepends = [];
		this.rebuild();
	}
};

var Tab = {
	groups: {},
	gidx: [],
	idx: -1,
	eidx: -1,
	last: null,
	cancels: [],
	disabled: {},

	simpleTabInput: function(node, order, classname, nodelaytab) {

		node.on("blur", function(e) {
			//console.log("bluring");
			e.preventDefault();
		});

		node.on('keydown', function(e) {
  			if (nodelaytab == undefined && e.which === 9) setTimeout(function() {Tab.cycle(e.shiftKey);}, 50);
		});

		return Tab.simpleTab(node, order, classname);
	},

	simpleTab: function(node, order, classname, focusnode) {

		return new function() {

			this.focus = function(m) {
				m.getNode('focus').addClass(m.$class);
				m.getNode().focus();
			};

			this.blur = function(m) {
				m.getNode('focus').removeClass(m.$class);				
				m.getNode().blur();
			};

			this._params = {};
			this._params.$node = node;
			this._params.$focusnode = focusnode;

			this._params.getNode = function(type) {
				if (type == 'focus' && this.$focusnode != undefined) {
					if (typeof this.$focusnode === 'function') return this.$focusnode();
					else return this.$focusnode;
				}

				if (typeof this.$node === 'function') return this.$node();
				else return this.$node;
			};

			if (classname == undefined || classname == "") classname = "focused";
			this._params.$class = classname;
			this.order = order;
		}
	},

	cancelStackAdd: function(id, fun) {
		for(var i in Tab.cancels) {
			if (Tab.cancels[i].id == id) {
				Tab.cancels[i].call = fun;
				return;
			}
		}

		Tab.cancels.push({"id": id, "call": fun});
	},

	cancelStackRemove: function(id) {
		for(var i in Tab.cancels) {
			if (Tab.cancels[i].id == id) {
				Tab.cancels.splice(i, 1);
				return;
			}
		}
	},

	keyDown: function(event) {
		try {
			if (Tab.idx == -1 && event.key == "Tab") {
				event.preventDefault();
				event.stopPropagation();
				return true;
			}

			var grp = Tab.gidx[Tab.idx];

			if (event.key == "Enter" && Tab.groups[grp].elements[Tab.eidx].defaultAction == 0) {
				Tab.groups[grp].elements[Tab.eidx].element.action(Tab.groups[grp].elements[Tab.eidx].params, event);
				event.preventDefault();
				event.stopPropagation();
			}

			if (event.key != "Enter" && Tab.groups[grp].elements[Tab.eidx].element.keyboard) {
				Tab.groups[grp].elements[Tab.eidx].element.keyboard(Tab.groups[grp].elements[Tab.eidx].params, event);
			}

			return true;
		} catch(e) {
//			event.preventDefault();
//			event.stopPropagation();
		}
	},

	keyUp: function(event) {
		if ((event.key == "Escape" || event.key == "Backspace") && Tab.cancels.length > 0) {
			var last = Tab.cancels.pop();

			last.call();

			event.preventDefault();
			event.stopPropagation();			
			player.blockBackspace = true;
			return false;
		}

		return true;
	},

	setGroup: function(group, order, pos) {
//		Tab.groups[group] = {"elements": [], "order": order, "enabled": true};
		Tab.groups[group] = new TabGroup(group, order, true);
		if (pos == undefined) Tab.gidx.push(group);
		else Tab.gidx.splice(pos, 0, group);
	},

	enableAllGroups: function() {
		for(var e in Tab.groups) {
			Tab.groups[e].enabled = true;
		}
	},

	disableGroupsExcept: function(grp) {
		for(var e in Tab.groups) {
			if (e != grp) Tab.groups[e].enabled = false;
		}
		Tab.groups[grp].enabled = true;
	},

	add: function(group, elem, params, defaultAction) {
		var id = group + "-" + Math.random().toString(36).substring(7) + "-" + Date.now();
		if (elem._params != undefined) params = elem._params;
		var obj = {"element":elem, "params": params, "defaultAction": defaultAction, "id": id};
		if (Tab.groups[group].order != "-")
			Tab.groups[group].append(obj, elem.order);
//			Tab.groups[group].elements.push(obj);
		else
			Tab.groups[group].prepend(obj, elem.order);
//			Tab.groups[group].elements.unshift(obj);

		return obj;
	},

	findById: function(group, id) {
		for(e in Tab.groups[group].elements) {
			if (Tab.groups[group].elements[e].id == id) return e;
		}

		return null;
	},

	addAfter: function(group, at, elem, params, defaultAction) {
		var id = group + "-" + Math.random().toString(36).substring(7) + "-" + Date.now();
		if (elem._params != undefined) params = elem._params;
		var obj = {"element":elem, "params": params, "defaultAction": defaultAction, "id": id};

		//Tab.groups[group].elements.splice(at, 0, obj);
		Tab.groups[group].insertAt(at, obj);

		return obj;
	},

	remove: function(group, id) {
		var found = null;

		Tab.groups[group].removeById(id);

		if (this.disabled[id] != undefined) delete this.disabled[id];
	},

	enable: function(group, id) {
		var found = null;
		for(var r in Tab.groups[group].elements) {
			if (Tab.groups[group].elements[r].id == id) {
				found = r;
				break;
			}
		}

		if (found != null) {
			Tab.groups[group].elements[r].disabled = false;
		}
		/*
		if (this.disabled[id] != undefined) {
			Tab.groups[group].elements.splice(this.disabled[id].pos, 0, this.disabled[id].element);

			delete this.disabled[id];
		}
		*/
	},

	enableAll: function(group) {
		/*
		for(var r in this.disabled)
			if (group == this.disabled[r].group) Tab.groups[group].elements.splice(this.disabled[r].pos, 0, this.disabled[r].element);

		for(var r in this.disabled)
			if (group == this.disabled[r].group) delete this.disabled[r];
		*/
		for(var r in Tab.groups[group].elements) {
			Tab.groups[group].elements[r].disabled = false;
		}
	},

	disable: function(group, id) {
		var found = null;
		for(var r in Tab.groups[group].elements) {
			if (Tab.groups[group].elements[r].id == id) {
				found = r;
				break;
			}
		}

		if (found != null) {
			Tab.groups[group].elements[r].disabled = true;
		}

		/*
		if (this.disabled[id] == undefined) {
			var found = null;
			for(var r in Tab.groups[group].elements) {
				if (Tab.groups[group].elements[r].id == id) {
					found = r;
					break;
				}
			}

			this.disabled[id] = {"group": group, "pos": found, "element": Tab.groups[group].elements[found]};
			Tab.groups[group].elements.splice(r, 1);
		}
		*/
	},

	clearGroup: function(group) {
		//Tab.groups[group].elements = [];
		Tab.groups[group].clear();
	},

	reset: function() {
		Tab.idx = -1;
		Tab.eidx = -1;

		if (Tab.last != null) Tab.last.element.blur(Tab.last.params);
	},

	cycle: function(shift) {
		var dt;

		//console.log(Tab.idx);

		if (HotSpotManager.closest) HotSpotManager.closest.hide();

		//console.log(Tab);
		if (Tab.last != null) Tab.last.element.blur(Tab.last.params);

		if (Tab.idx == -1) {
			Tab.idx = 0;
		}

		grp = Tab.gidx[Tab.idx];
		
		if (!Tab.groups[grp].enabled) {
			Tab.idx ++;
			dt = shift ? -1 : 1;
			while(Tab.idx < Tab.gidx.length && !Tab.groups[Tab.gidx[Tab.idx]].enabled) Tab.idx += dt;
			if (!Tab.groups[Tab.gidx[Tab.idx]].enabled) return;
		}
		
		if (!shift) {
			Tab.eidx ++;

			grp = Tab.gidx[Tab.idx];
			if (Tab.eidx < Tab.groups[grp].elements.length && Tab.groups[grp].elements[Tab.eidx].disabled === true) {
				Tab.cycle(shift);
				return;
			}
//			while(Tab.eidx < Tab.groups[grp].elements.length && Tab.groups[grp].elements[Tab.eidx].disabled === true) Tab.eidx ++;

			if (Tab.eidx >= Tab.groups[grp].elements.length) {
				Tab.eidx = 0;

				Tab.idx ++
				while(Tab.idx < Tab.gidx.length && (Tab.groups[Tab.gidx[Tab.idx]].elements.length == 0 || !Tab.groups[Tab.gidx[Tab.idx]].enabled)) Tab.idx ++;

				if (Tab.idx >= Tab.gidx.length) Tab.idx = 0;
				while ((Tab.groups[Tab.gidx[Tab.idx]].elements.length == 0 || !Tab.groups[Tab.gidx[Tab.idx]].enabled) && Tab.idx < Tab.gidx.length) Tab.idx ++;
			}

			grp = Tab.gidx[Tab.idx];
			
			Tab.groups[grp].elements[Tab.eidx].element.focus(Tab.groups[grp].elements[Tab.eidx].params);
			Tab.last = Tab.groups[grp].elements[Tab.eidx];
		} else {
			Tab.eidx --;

			grp = Tab.gidx[Tab.idx];
//			while(Tab.eidx >= 0 && Tab.groups[grp].elements[Tab.eidx].disabled === true) Tab.eidx --;
			if(Tab.eidx >= 0 && Tab.groups[grp].elements[Tab.eidx].disabled === true) {
				Tab.cycle(shift);
				return;
			}

			if (Tab.eidx < 0) {				

				Tab.idx --
				while(Tab.idx > 0 && (Tab.groups[Tab.gidx[Tab.idx]].elements.length == 0 || !Tab.groups[Tab.gidx[Tab.idx]].enabled)) Tab.idx --;

				if (Tab.idx < 0) Tab.idx = Tab.gidx.length - 1;
				while ((Tab.groups[Tab.gidx[Tab.idx]].elements.length == 0 || !Tab.groups[Tab.gidx[Tab.idx]].enabled) && Tab.idx > 0) Tab.idx --;

				grp = Tab.gidx[Tab.idx];
				Tab.eidx = Tab.groups[grp].elements.length - 1;
			}

			grp = Tab.gidx[Tab.idx];

			Tab.groups[grp].elements[Tab.eidx].element.focus(Tab.groups[grp].elements[Tab.eidx].params);
			Tab.last = Tab.groups[grp].elements[Tab.eidx];			
		}
	}
}